<template>
<div>

    <nav class="navbar has-shadow" :transparent='true' role="navigation" aria-label="main navigation">
        <div class="container">

            <div class="navbar-brand">
                <router-link class="navbar-item itm" to="/dm/dashboard">
                    <img src="/static/LOGO_1.png" alt="LetsUpgrade Online Learning">
                </router-link>
                <div class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div class="navbar-menu itm2" :class="{ 'is-active': showNav }">
                <div class="navbar-end">

                    <router-link class="navbar-item" activeClass="is-selected" to="/app/dashboard">
                        <i class="fas fa-tachometer-alt is-large"></i>&ensp;Dashboard&ensp;
                    </router-link>

                    <router-link class="navbar-item" activeClass="is-selected" to="/app/users">
                        <i class="fas fa-user-tie"></i>&ensp;Users
                    </router-link>
                    <router-link class="navbar-item" activeClass="is-selected" to="/app/course">
                        <i class="fas fa-graduation-cap"></i>&ensp;Course
                    </router-link>
                    <!-- <router-link class="navbar-item" activeClass="is-selected" to="/app/dashboard">
                        <i class="fas fa-cogs"></i>&ensp;Settings
                    </router-link> -->

                    <!-- <router-link class="navbar-item" activeClass="is-selected" to="/app/dashboard">
                        <i class="fas fa-id-badge"></i>&ensp;Profile
                    </router-link> -->

                    <b-navbar-item tag="div">

                        <a @click="logout()" class="button is-warning">
                            <strong>Logout</strong>
                        </a>

                    </b-navbar-item>
                    <!--   <a class="button navbar-item" style="background-color:#ffc107" @click="logout()">
                        <i class="fas fa-sign-out-alt"></i>&ensp;Sign Out
                    </a> -->

                </div>
            </div>
        </div>
    </nav>

    <div class="section ">
        <div class="container">
            <router-view />
        </div>
    </div>
</div>
</template>

<script>
import Firebase from '../../lib/Firebase';
/* import Firestore from "../../lib/Firestore"; */
export default {
    name: 'navbar',
    created() {
        var vm = this
        Firebase.auth().onAuthStateChanged(function (user) {

            if (user) {
                vm.uid = user.uid
                let obj = {
                state: 'online',
            }
                Firebase.firestore().collection('users').doc(user.uid).update(obj);
                let docRef = Firebase.firestore().collection("users").doc(user.uid);
                docRef.get().then(doc => {
                    vm.user = doc.data()
                    console.log(vm.user)
                })
            } else {
                // No user is signed in.
            }
        });
    },
    data() {
        return {
            showNav: false,
            unreads: null,
            uid: null,
            user: {
                name: ''
            }
        }
    },
    computed: {
        showAnalytics() {
            return this.$route.path === '/dm/analytics';
        }
    },

    methods: {

        logout() {
            let obj = {
                state: 'offline',
            }
            Firebase.firestore().collection('users').doc(this.uid).update(obj);

            Firebase.auth().signOut().then(function () {
                // Sign-out successful.

                console.log("SignOut SuccessFul")
                this.$router.push('/');

            }).catch(function (error) {
                // An error happened.
            });

        },

        toggleNav() {
            this.isNavOpen = !this.isNavOpen;
        }
    }
};
</script>

<style>
.main-container {
    margin-top: 2rem !important;
}

/* .logo-img{

  display: flex;
  flex-direction: column;
} */
/* .itm {
    font-family: 'Lora', serif;
}
 */
/* .itm2 .navbar-item {
    font-family: "Roboto", sans-serif;
} */

.navbar {
    background-color: rgb(255, 255, 255);
}

@media screen and (max-width: 700px) {
    .sidenav {
        width: 100%;
        height: auto;
        position: relative;
    }

    .sidenav a {
        float: left;
    }

    div.content {
        margin-left: 0;
    }
}

@media screen and (max-width: 400px) {
    .sidenav a {
        text-align: center;
        float: none;
    }
}

.sidenav a:hover {
    color: #f1f1f1;
}

.main {
    margin-left: 160px;
    /* Same as the width of the sidenav */
    font-size: 28px;
    /* Increased text to enable scrolling */
    padding: 0px 10px;
}

@media screen and (max-height: 450px) {
    .sidenav {
        padding-top: 15px;
    }

    .sidenav a {
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Navbar.vue